<template>
  <section class="section">
    <div class="container">
      <div class="section__header section__header--center">
        <span class="section__label">Двухконтурный расчёт</span>
        <h2 class="section__title">Онлайн-оценка сейчас — авторитетная ведомость в&nbsp;день выплаты</h2>
        <p class="section__subtitle">
          Один и тот же расчёт работает в двух контурах: сотрудник в любой момент видит
          предварительную сумму, а официальную считает сервер по всей компании.
        </p>
      </div>
      <div class="contours">
        <div v-for="c in contours" :key="c.title" class="contour-card" :class="c.accent ? 'contour-card--accent' : ''">
          <div class="contour-card__head">
            <div class="contour-card__icon">
              <ui-icon :name="c.icon" :size="24" />
            </div>
            <div>
              <span class="contour-card__tag">{{ c.tag }}</span>
              <h3 class="contour-card__title">{{ c.title }}</h3>
            </div>
          </div>
          <ul class="contour-card__list">
            <li v-for="item in c.items" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
      <p class="contours__note">
        Серверный расчёт — единый источник истины: он перезаписывает онлайн-оценку,
        закрывает период и попадает в ведомость для бухгалтерии.
      </p>
    </div>
  </section>
</template>

<script>
import UiIcon from '../ui/UiIcon.vue'
export default {
  name: 'ContoursSection',
  components: { UiIcon },
  data() {
    return {
      contours: [
        {
          icon: 'eye',
          tag: 'Контур 1',
          title: 'Онлайн-оценка сотруднику',
          items: [
            'Сотрудник и руководитель видят предварительную премию в любой момент периода',
            'Считается мгновенно по актуальным данным — без ожидания',
            'Помогает планировать и снимает вопросы до дня выплаты',
          ],
        },
        {
          icon: 'layers',
          tag: 'Контур 2',
          title: 'Авторитетный серверный расчёт',
          accent: true,
          items: [
            'Сервер считает премии по всей компании за период',
            'Результат фиксируется и закрывает период от случайных правок',
            'Идёт в расчётную ведомость для бухгалтерии и 1С',
          ],
        },
      ],
    }
  },
}
</script>

<style scoped>
.contours {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
.contour-card {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 28px;
  transition: var(--transition);
}
.contour-card:hover { box-shadow: var(--shadow); }
.contour-card--accent {
  border-color: var(--primary);
  background: var(--primary-light);
}
.contour-card__head {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 20px;
}
.contour-card__icon {
  width: 48px; height: 48px;
  border-radius: 12px;
  background: white;
  border: 1px solid var(--border);
  color: var(--primary);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.contour-card__tag {
  display: block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--primary);
  font-weight: 700;
}
.contour-card__title {
  font-size: 1.0625rem;
  font-weight: 700;
  color: var(--dark);
}
.contour-card__list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.contour-card__list li {
  color: var(--gray);
  font-size: 0.9375rem;
  line-height: 1.6;
  padding-left: 24px;
  position: relative;
}
.contour-card__list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--secondary);
  font-weight: 700;
}
.contours__note {
  margin-top: 28px;
  text-align: center;
  color: var(--gray);
  font-size: 0.9375rem;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 768px) {
  .contours { grid-template-columns: 1fr; }
}
</style>
